import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import Task, { TaskPriority } from "@/models/Task";
import { useDataProvider } from "@/providers/DataProvider";
import { useNavigate, useParams } from "react-router-dom";
import { TaskForm } from "@/components/TaskForm";

export const TaskEditDialog: React.FC = () => {
  const { tasks, categories, tags, updateTask } = useDataProvider();
  const { taskId } = useParams<{ taskId: string }>();
  const navigate = useNavigate();

  const task = tasks.find((t) => t.id === (taskId || "")) || null;

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [categoryId, setCategoryId] = useState<string | null>(null);
  const [priority, setPriority] = useState<TaskPriority>(TaskPriority.LOW);
  const [dueDate, setDueDate] = useState<string>("");
  const [selectedTagIds, setSelectedTagIds] = useState<string[]>([]);

  useEffect(() => {
    if (task) {
      setTitle(task.title);
      setDescription(task.description);
      setCategoryId(task.categoryId);
      setPriority(task.priority);
      setDueDate(task.dueDate ? moment(task.dueDate).format("YYYY-MM-DD") : "");
      setSelectedTagIds(task.tagsIds || []);
    }
  }, [task]);

  const handleHide = () => {
    navigate(-1);
  };

  const handleSave = () => {
    if (!task || title.trim() === "") return;
    const updatedTask = new Task({
      ...task,
      title,
      description,
      categoryId,
      priority,
      dueDate: dueDate ? moment(dueDate) : null,
      tagsIds: selectedTagIds,
      updatedAt: moment(),
    });
    updateTask(updatedTask);
    handleHide();
  };

  if (!task) {
    return (
      <Modal show centered onHide={handleHide}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-danger">Task not found.</div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleHide}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <Modal show onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Task</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TaskForm
          title={title}
          setTitle={setTitle}
          description={description}
          setDescription={setDescription}
          categoryId={categoryId}
          setCategoryId={setCategoryId}
          priority={priority}
          setPriority={setPriority}
          dueDate={dueDate}
          setDueDate={setDueDate}
          selectedTagIds={selectedTagIds}
          setSelectedTagIds={setSelectedTagIds}
          categories={categories}
          tags={tags}
          onSubmit={handleSave}
          onCancel={handleHide}
          submitLabel="Save Changes"
        />
      </Modal.Body>
    </Modal>
  );
};

export default TaskEditDialog;
